const initApilogData = {
  
}


export function apilogData(
  state = initApilogData,
  action
) {
  switch (action.type) {
    case "APILOG_FETCH_DATA_SUCCESS":
      return action.dataApilog;
    default:
      return state;
  }
}
